import { Utilities as U } from "../utilities/utilities.model";

export class AccessReference {
  access_token: string;
  refresh_token: string;
  scope: string;
  token_type: string;
  expires_in: number;

    constructor(model?: any) {
        if (model) {
            this.access_token = model.access_token;
            this.refresh_token = model.refresh_token;
            this.scope = model.scope;
            this.token_type = model.token_type;
            this.expires_in = model.expires_in;
        }
    }

    public isValid(): boolean {
        return (
            !U.isEmpty(this.access_token)  &&
            !U.isEmpty(this.refresh_token) &&
            !U.isEmpty(this.scope)         &&
            !U.isEmpty(this.token_type)    &&
            !U.isEmpty(this.expires_in)
        )
    }
}
